import { Controller } from "@hotwired/stimulus";

// Lance la vidéo de présentation en lecture automatique muette et en boucle.
// Affiche un bouton « Activer le son » que l'utilisateur peut cliquer pour
// passer en lecture sonore. Si l'autoplay muet est bloqué par le navigateur,
// le poster + les contrôles natifs permettent une lecture manuelle.
export default class extends Controller {
  static targets = ["video", "soundButton"];

  connect() {
    if (!this.hasVideoTarget) return;

    // Garantit la lecture automatique muette (certains navigateurs ignorent
    // l'attribut autoplay si la promesse play() n'est pas explicitement appelée).
    const playPromise = this.videoTarget.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {
        // Autoplay refusé : on laisse le poster et les contrôles natifs.
      });
    }

    // Si l'utilisateur réactive le son via les contrôles natifs, on cache le bouton.
    this.videoTarget.addEventListener("volumechange", this.syncButton);
  }

  disconnect() {
    if (this.hasVideoTarget) {
      this.videoTarget.removeEventListener("volumechange", this.syncButton);
    }
  }

  enableSound() {
    if (!this.hasVideoTarget) return;

    this.videoTarget.muted = false;
    this.videoTarget.volume = 1;

    const playPromise = this.videoTarget.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {});
    }

    this.hideButton();
  }

  syncButton = () => {
    if (this.videoTarget.muted) return;
    this.hideButton();
  };

  hideButton() {
    if (this.hasSoundButtonTarget) {
      this.soundButtonTarget.classList.add("hidden");
    }
  }
}
